import React from "react";
import Loading from "./Loading";

const Table = ({ column, data, loader }) => {
  return (
    <>
      <table className="table">
        <thead>
          <tr className="border rounded">
            {column?.map((col, ind) => {
              if (col.labelComponent) {
                return (
                  <th className="border-0" key={ind}>
                    {col.labelComponent(col, data)}
                  </th>
                );
              }
              return (
                <th className="border-0 " key={ind}>
                  {col.label}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 &&
            !loader &&
            data?.map((item, key) => (
              <tr key={key}>
                {column.map((col, ind) => {
                  if (col.isComponent) {
                    return (
                      <td className="bg-transparent text-left" key={ind}>
                        {col.component(item, key, data)}
                      </td>
                    );
                  }

                  return (
                    <td className="bg-transparent text-left" key={ind}>
                      <p className={`${col.classNames} m-0`}>
                         {/* {item[col.id]} */}
                        {typeof item[col.id] === "string"
                          ? item[col.id].charAt(0).toUpperCase() +
                            item[col.id].slice(1)
                          : item[col.id]}
                      </p>
                    </td>
                  );
                })}
              </tr>
            ))}

          {data?.length <= 0 && !!!loader && (
            <tr>
              <td colSpan={column.length}>
                <p className={`text-center ${column.classNames}`}>
                  No Data Found!
                </p>
              </td>
            </tr>
          )}

          {!!loader && (
            <tr>
              <td colSpan={column.length} align="center">
                <Loading />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Table;
